import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { searchIcon, SVGIcon } from "@progress/kendo-svg-icons";

interface SupportCard {
  icon: string;
  title: string;
  description: string;
  route?: string;
}

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {

  public searchIcon: SVGIcon = searchIcon;

  cards: SupportCard[] = [
    
    {
      icon: 'caret-tr',
      title: 'Submit an iRTA',
      description: 'Submit a new internal request',
      route: '/rta/create'
    },
    {
      icon: 'file-txt',
      title: 'Submit an eRTA',
      description: 'Submit a new external request',
      route: '/edit'
    },
    {
      icon: 'inherited',
      title: 'Tickets',
      description: 'Access your existing RTAs',
      route: '/dashboard'
    }
  ];

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  onCardClick(card: SupportCard): void {
    if (card.route) {
      this.router.navigate([card.route]);
    }
  }

}
